import React from 'react';
import CreatorTable from "../../microComponents/tablePages/CreatorTable";
import PalletListOrderColumn from "./PalletListOrderColumn";

const PalletListOrder = ({id}) => {
    const [columns] = PalletListOrderColumn();

    return (
        <div>
            <CreatorTable columns={columns} listAddress={`Order/pallets/${id}`}
                          expandable={{
                              expandedRowRender: (record) => (
                                  <div className='flex gap-4 items-center flex-wrap'>
                                      <div className='keyValue'>
                                          <div className="key">توضیحات:</div>
                                          <div className="value"> {record.description}</div>
                                      </div>


                                  </div>
                              ),
                          }}
            />
        </div>
    );
};

export default PalletListOrder;